import React from "react";
import { Search, X } from "lucide-react";
import { CATEGORY_GROUPS, STATUSES } from "../lib/api";

export function filterDocs(docs, search, category = "all", status = "all") {
  const q = search.trim().toLowerCase();
  return docs.filter((d) =>
    (!q || (d.title || "").toLowerCase().includes(q)) &&
    (category === "all" || d.category === category) &&
    (status === "all" || d.status === status));
}

const DARK_FIELD = { backgroundColor: "#112A57", border: "1px solid #1E3A8A", color: "#fff" };
const LIGHT_FIELD = { backgroundColor: "#fff", border: "1px solid #E5E7EB", color: "#1A1A1A" };

export function DocSearchBar({ search, setSearch, category, setCategory, status, setStatus, dark = false, testPrefix = "doc" }) {
  const field = dark ? DARK_FIELD : LIGHT_FIELD;
  const iconColor = dark ? "#9CA3AF" : "#6B7280";
  return (
    <div className="flex flex-wrap items-center gap-2 mb-4" data-testid={`${testPrefix}-search-bar`}>
      <div className="relative flex-1 min-w-[220px]">
        <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: iconColor }} />
        <input
          data-testid={`${testPrefix}-search-input`}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by name..."
          className="w-full rounded-lg pl-9 pr-8 py-2 text-sm outline-none focus:ring-2 focus:ring-[#F97316]"
          style={field}
        />
        {search && (
          <button data-testid={`${testPrefix}-search-clear`} onClick={() => setSearch("")}
            className="absolute right-2.5 top-1/2 -translate-y-1/2" style={{ color: iconColor }}>
            <X size={14} />
          </button>
        )}
      </div>
      {setCategory && (
        <select
          data-testid={`${testPrefix}-category-filter`}
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className="rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#F97316]"
          style={field}
        >
          <option value="all">All categories</option>
          {CATEGORY_GROUPS.map((g) => <option key={g.cat} value={g.cat}>{g.label}</option>)}
        </select>
      )}
      {setStatus && (
        <select
          data-testid={`${testPrefix}-status-filter`}
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          className="rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#F97316]"
          style={field}
        >
          <option value="all">All statuses</option>
          {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      )}
    </div>
  );
}
